var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yvw4vamt9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.803 1.063a3.625 3.625 0 0 1 5.134 0 3.626 3.626 0 0 1 0 5.134l-2.21 2.21-7.84 7.84a1 1 0 0 1-.436.256l-5.18 1.46a1 1 0 0 1-1.234-1.234l1.46-5.18a1 1 0 0 1 .256-.436l7.838-7.838.002-.002.002-.002 2.208-2.208zm3.72 3.72L20.02 6.286 17.714 3.98l1.503-1.503c.64-.64 1.666-.64 2.306 0 .64.64.64 1.666 0 2.306zM18.606 7.7 16.3 5.394l-6.948 6.948-.905 3.211 3.21-.905L18.607 7.7zM5 5c-2.762 0-5 2.238-5 5v9c0 2.762 2.238 5 5 5h9c2.762 0 5-2.238 5-5v-3a1 1 0 1 0-2 0v3c0 1.658-1.342 3-3 3H5c-1.658 0-3-1.342-3-3v-9c0-1.658 1.342-3 3-3h3a1 1 0 0 0 0-2H5z",
    fill: "#8A8DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yvw4vamt9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0d4b57c949342904371132cd2ecc2a11.svg";
export { ForwardRef as ReactComponent };